// @view/panels/document/FinalEditsPage.panel.tsx
import React from "react";
import EmptyView from "@view/EmptyView";
import FinalEditsComponent from "@view/document/FinalEdits";
import type { DocumentFinalEditsViewProps } from "@ps-bridge/contracts/documentFinalEdits";

export type FinalEditsPagePhase = "missing" | "ready";

type FinalEditsPagePanelProps = {
  phase: FinalEditsPagePhase;
  viewProps: DocumentFinalEditsViewProps;
};

const FinalEditsPagePanel: React.FC<FinalEditsPagePanelProps> = ({
  phase,
  viewProps,
}) => {
  const render = {
    missing: <EmptyView />,
    ready: <FinalEditsComponent {...viewProps} />,
  } as const satisfies Record<FinalEditsPagePhase, React.ReactElement>;

  return (
    <div
      data-testid="page-finalEdits"
      data-page-state="ready"
      data-page-phase={phase}
    >
      {render[phase]}
    </div>
  );
};

export default FinalEditsPagePanel;
